import {useState} from "react";
import {ChevronDown} from "lucide-react";

function Faq() {
    const [active, setActive] = useState(0);

    const questions = [
        {
          q: "Puis-je personnaliser la liste des traitements et leurs prix ?",
          a: "Oui, vous avez une liberté totale pour ajouter vos propres traitements (Détartrage, Couronne, etc.) et fixer vos prix souhaités."
        },
        {
          q: "Est-ce que l'assistante peut utiliser le logiciel ?",
          a: "Absolument. Vous pouvez créer un compte dédié pour votre assistante avec des accès limités selon vos besoins."
        },
        {
          q: "Mes données sont-elles sécurisées ?",
          a: "Oui, vos données patients sont chiffrées et stockées sur des serveurs hautement sécurisés. Seul votre cabinet y a accès."
        },
        {
          q: "Suis-je accompagné en cas de problème ?",
          a: "Nous sommes à vos côtés pour vous assister au quotidien. Nos accompagnateurs vous aideront à bien comprendre l’utilisation"
        },
        {
          q: "Pourrais-je extraire mes données ?",
          a: "Oui, ce sont vos données. Il vous suffit de nous en faire la demande."
        },
        {
          q: "Pourrais-je arrêter mon abonnement ?",
          a: "Oui, votre abonnement est sans engagement, vous pouvez l'arrêté à tout moment."
        }
    ];

    return (
        <section id="faq" className="py-20 px-4 bg-slate-50">
            <div className="max-w-3xl mx-auto">
                <h3 className="text-3xl font-extrabold text-slate-900 text-center mb-12">Questions fréquentes</h3>
                <div className="space-y-4">
                    {questions.map((item, i) => (
                        <div key={i} className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
                            <button
                                onClick={() => setActive(active === i ? null : i)}
                                className="w-full p-6 text-left flex justify-between items-center hover:bg-slate-50 transition-colors"
                            >
                                <span className="font-bold text-slate-800">{item.q}</span>
                                <ChevronDown className={`transition-transform ${active === i ? 'text-primary rotate-180' : ''}`} size={20} />
                            </button>
                            {active === i && (
                                <div className="p-6 pt-0 text-slate-600 leading-relaxed border-t border-slate-50">
                                    {item.a}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Faq;